'use strict';

angular.module('app.engagementScores', [])
    .controller('AdminEngagementScoresCtrl', ['$scope', '$modal', 'engagementScoresService',
        function ($scope, $modal, engagementScoresService) {
    
            function loadData(param) {
                $scope.engagementScoresBlog = [];
                $scope.engagementScoresInstagram = [];
                $scope.engagementScoresYoutube = [];
                $scope.engagementScoresFacebook = [];
                $scope.engagementScoresTiktok = [];
                engagementScoresService.getEngagementScores(true)
                    .then(function(response) {
                        angular.forEach(response.data, function(item) {
                            if(item.platform_id == 1){
                                $scope.engagementScoresBlog.push(item);
                            } else if(item.platform_id == 2){
                                $scope.engagementScoresInstagram.push(item);
                            } else if(item.platform_id == 6){
                                $scope.engagementScoresYoutube.push(item);
                            } else if(item.platform_id == 7){
                                $scope.engagementScoresFacebook.push(item);
                            } else if(item.platform_id == 8){
                              $scope.engagementScoresTiktok.push(item);
                            }
                        });
                    }, function(response) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    })
            }

            loadData();  

            $scope.updateEngagementScores = function(){
                var updateEngagementScoresModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/admin/engagementScores/updateEngagementScores/updateEngagementScores.html?app_v=deployDate',
                    controller: 'updateEngagementScoresCtrl'
                });

                $scope.updateEngagementScoresModalInstance = updateEngagementScoresModalInstance;
            }

            $scope.resetEngagementScores = function(){
                loadData();
            }
}])
